import { ChangeDetectionStrategy, Component } from '@angular/core';
import { recentlyViewedConfig } from '@df/catalog-ui/recently-viewed/recently-viewed.config';
import { RelatedProductsComponentDef } from '@df/catalog-ui/related-products/related-products.component.def';

recentlyViewedConfig.mode = 'child';

let uid = 0;
@Component({
    selector: 'related-products',
    templateUrl: './related-products.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./related-products.scss']
})
export class RelatedProductsComponent extends RelatedProductsComponentDef {
    private uid = uid++;

    getEnginesName(): string {
        return (
            (Array.isArray(this.options.engines)
                ? this.options.engines?.map(e => (typeof e === 'string' ? e : e.id))?.join('-')
                : this.options.engines) +
            '-' +
            this.uid
        );
    }

    get pcSlides() {
        return [1, 2, 4, 5][this.client.sizeId];
    }

    get pcSlidesCeil() {
        return Math.ceil(this.pcSlides);
    }

    get pcGutter() {
        return [8, 16, 16, 16][this.client.sizeId] + 'px';
    }
}
